import { useEffect, useState } from 'react';
import { SignedIn, SignedOut } from '@clerk/clerk-react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import ISO8601 from '@/util/iso-dates';
import { AssetRole } from '@/models/asset';
import { SubscriptionLevel, type Profile } from '@/models/profile';
import { PersonRole } from '@/models/person';
import { useAuthorization, profileSelector } from '@/hooks/useAuthorization.hook';
import Authorizor from '@/util/authorizor';
import Loading from '@/components/Loading';
import Authorized from '@/components/Authorized';
import Welcome from '@/components/Welcome';
import AnonymousWelcome from '@/components/AnonymousWelcome';
// import Loading from '@/components/Loading';
import styles from './Home.module.css';

interface HomeProps {
  entity?: AssetRole;
}

type HomeSearchParams = HomeProps;


export const Route = createFileRoute('/home/')({
  component: Home,
})

const logRoute = () => {
  console.log("Home route");
}

const HomeAuthorized = (props: HomeProps) => {
  // const [subscribed, setSubscribed] = useState(true);
  // const [profileInitialized, setProfileInitialized] = useState(false);
  const [busy, setBusy] = useState(true);
  const profile = useAuthorization(profileSelector);
  const navigate = useNavigate();


  const checkSubscribed = (profile?: Profile): boolean => {
    if (!profile || !profile.subscription) return false;
    if (profile.subscription.type == SubscriptionLevel.NONE) return false;
    const trialExpiration = profile.subscription.trialExpiration;
    const expiration = profile.subscription.expiration;
    const nowISO = ISO8601.nowUTC();
    if (expiration) {
      return expiration > nowISO;
    }
    if (trialExpiration) {
      return trialExpiration > nowISO;
    }
    return false;
  }

  useEffect(() => {
    const nextUrl = (): string => {
      let result: string = '/home'
      const subscribed = checkSubscribed(profile);
      const guestEntity = Authorizor.guestEntity
      if (!subscribed && guestEntity.role != PersonRole.NONE) {
        if (guestEntity.role == PersonRole.REVIEWER) {
          result = `/draftsubmission/${Authorizor.guestEntity.jumpId}`
        } else if (guestEntity.role == PersonRole.JUDGE) {
          console.warn("TODO: Navigate to judge page")
        }
      } else if (!subscribed) {
        result = '/subscribe'
      }
      return result
    }
    if (profile) {
      console.log("Running useEffect in /home");
      if (!profile.initialized) {
        // if user has never visited the profile page then go there now
        navigate({
          to: "/profile",
          search: {
            next: nextUrl(),
            show_subscribe: false,
          },
          viewTransition: true
        });
      }
      // } else {
      //   navigate({
      //     to: nextUrl(),
      //     viewTransition: true
      //   })
      // }
      setBusy(false);
    }
  }, [profile]);

  if (busy) {
    <Loading />
  }

  return <Welcome entity={props.entity} />

}

const WelcomeLoader = (props: HomeProps) => { 
  return (
    <>
      <SignedIn>
        <Authorized>
          <HomeAuthorized entity={props.entity} />
        </Authorized>
      </SignedIn>
      <SignedOut>
        <AnonymousWelcome />
      </SignedOut>
    </>
  );

}

function Home() { 
  const searchParams: HomeSearchParams = Route.useSearch();

  logRoute();

  return( 
    <div className={styles.pageContainer}>
        <WelcomeLoader entity={searchParams.entity} />
    </div> 
  ) 
}